/**
 * @file VeriomeNumberField.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Apr 08, 2022 16:49
 */
import PropTypes from 'prop-types';

import TextField from '@mui/material/TextField';

import { isNumber } from 'src/@common/validatorUtilities';

function VeriomeNumberField(props) {
    const {
        className = '',
        fieldErrors,
        fieldLabel,
        fieldName,
        currentValue,
        helpText = '',
        isFocus = false,
        isFullWidth = false,
        isRequired = false,
        isDisabled = false,
        sxStyle = null,
        handleBlur = () => { },
        handleChange,
    } = props;

    const inputProps = null;

    const handleLocalChange = (event) => {
        let testValue = null;

        if (event.preventDefault) {
            event.preventDefault();
        }

        if (event.target) {

            testValue = Number(event.target.value);

            if (isNumber(testValue) === true) {
                handleChange(event, fieldName);
            }
        }
    };

    return (
        <div className={className} >
            <TextField
                key={`${fieldName}-key`}
                id={`${fieldName}-field`}
                name={`${fieldName}-field`}
                label={fieldLabel ? fieldLabel : ''}
                sx={sxStyle}
                value={currentValue ? currentValue : ''}
                autoComplete="no-autocomplete"
                autoFocus={isFocus}
                disabled={isDisabled}
                onChange={(event) => {
                    handleLocalChange(event);
                }}
                onBlur={() => {
                    handleBlur(fieldName);
                }}
                fullWidth={isFullWidth}
                required={isRequired}
                size="small"
                margin="dense"
                variant="filled"
                error={fieldName ? Boolean(fieldErrors[fieldName]) : false}
                helperText={fieldErrors[fieldName] || helpText}
                InputProps={inputProps}
            />
        </div >
    );
}

VeriomeNumberField.propTypes = {
    className: PropTypes.string,
    fieldErrors: PropTypes.object,
    fieldLabel: PropTypes.string.isRequired,
    fieldName: PropTypes.string.isRequired,
    currentValue: PropTypes.string,
    helpText: PropTypes.string,
    isDisabled: PropTypes.bool,
    isFocus: PropTypes.bool,
    isFullWidth: PropTypes.bool,
    isRequired: PropTypes.bool,
    sxStyle: PropTypes.object,
    handleBlur: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
};

export default VeriomeNumberField;